import React from 'react';
import { Form, Input } from 'antd';

const HiddenField = ({ form, name, initialValue }) => {
  return (
    <Form.Item style={{ margin: 0, padding: 0 }}>
      {form.getFieldDecorator(name, { initialValue })(<Input type="hidden" />)}
    </Form.Item>
  );
};

export default HiddenField;
